<template>
	<lesson-resource-item-base :resource="resource">
		<tooltip
			v-if="getDescription"
			:text="getDescription"
			position="left"
		>
			<icon
				data-element="description-icon"
				icon="info"
				colour="transparent"
			/>
		</tooltip>
	</lesson-resource-item-base>
</template>

<script>

	import LessonResourceItemBase from '@/components/lessons/LessonResourceItemBase';
	import Icon from '@/components/ui/Icon';
	import Tooltip from '@/components/ui/Tooltip';

	export default {
		components: {
			LessonResourceItemBase,
			Icon,
			Tooltip
		},
		props: {
			resource: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			getDescription () {
				return this.resource?.description;
			}
		},
		methods: {}
	};

</script>

<style lang="scss" scoped>

	::v-deep [data-element='description-icon'] {
		flex-shrink: 0;
		width: rem(28);
		height: auto;
		cursor: pointer;
		* {
			fill: $c-brand-grey-lighter-2;
		}
	}

	::v-deep [data-component='tooltip'] {
		[data-element='tooltip-text-wrapper'] {
			&[data-position='left'] {
				display: inline-flex;
				min-height: auto;
				min-width: auto;
				width: auto;
				max-width: 200px;
			}
		}
	}

</style>
